module.exports = __webpack_public_path__ + "media/images/area/icon_weather_26-72b4b790b00b528e2b2960eb444f3a8f.png";